// src/components/NavMobile.js
import React from "react";
import { Link } from "react-router-dom"; 
import { navigation, business } from "../data";
import { 
  IoLogoFacebook, 
  IoLogoInstagram, 
  IoLogoWhatsapp, 
  IoLogoYoutube,
  IoClose 
} from "react-icons/io5";

const NavMobile = ({ isOpen, onClose }) => {
  // Don't render if not open
  if (!isOpen) return null;

  // Check if admin is logged in
  const isAdmin = localStorage.getItem('adminAccess') === 'true';
  
  // Filter navigation - show admin only if logged in
  const filteredNav = isAdmin 
    ? navigation 
    : navigation.filter(item => item.name !== "admin");

  const navItems = filteredNav.map((item, index) => (
    <li key={index} className="w-full">
      <Link
        to={item.href}
        className={`block text-white text-lg capitalize hover:text-yellow-400 hover:bg-blue-800/50 px-6 py-3 rounded-lg transition-all duration-300 border-b border-blue-800/30 ${
          item.name === "admin" ? "bg-yellow-500 text-blue-900 hover:bg-yellow-400 hover:text-blue-900" : ""
        }`}
        onClick={onClose}
      >
        {item.name === "admin" ? "⚙️ Admin" : item.name}
      </Link>  
    </li>
  ));

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-40"
        onClick={onClose}
      />
      
      {/* Navigation Panel */}
      <div className="fixed top-0 right-0 w-[85%] max-w-sm h-full bg-gradient-to-b from-blue-900 to-blue-950 shadow-2xl z-50 animate-slideIn">
        {/* Close Button */}
        <div className="flex justify-end p-4">
          <button
            onClick={onClose}
            className="text-white text-3xl hover:text-yellow-400 transition-colors"
          >
            <IoClose />
          </button>
        </div>

        {/* Brand Logo */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto shadow-lg">
            <span className="text-blue-900 font-bold text-3xl">KN</span>
          </div>
          <h2 className="text-white text-2xl font-bold mt-3">{business.name}</h2>
          <p className="text-yellow-400 text-sm tracking-[4px] uppercase">
            {business.category}
          </p>
        </div>

        {/* Navigation Links */}
        <ul className='capitalize text-center flex flex-col items-center gap-y-1 px-4 text-xl font-medium'>
          {navItems}
        </ul>

        {/* WhatsApp Button */}
        <div className="px-6 mt-6">
          <a
            href={business.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-3 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl"
            onClick={onClose}
          >
            <IoLogoWhatsapp className="text-xl" />
            Join WhatsApp
          </a>
        </div>

        {/* Social Links */}
        <div className="flex justify-center gap-6 mt-6">
          <a
            href={business.youtube}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-red-500 transition-colors text-2xl"
          >
            <IoLogoYoutube />
          </a>
          <a
            href={business.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-blue-500 transition-colors text-2xl"
          >
            <IoLogoFacebook />
          </a>
          <a
            href={business.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-pink-500 transition-colors text-2xl"
          >
            <IoLogoInstagram />
          </a>
          <a
            href={business.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-green-500 transition-colors text-2xl"
          >
            <IoLogoWhatsapp />
          </a>
        </div>

        {/* Contact Info */}
        <div className="text-center mt-6 px-6 pb-6">
          <p className="text-blue-300 text-sm">
            📞 {business.phone}
          </p>
          <p className="text-blue-300 text-sm mt-1">
            ✉️ {business.email}
          </p>
          <p className="text-blue-400 text-xs mt-4">
            © {business.name} 2026 - All Rights Reserved
          </p>
        </div>
      </div>

      {/* Add animation styles */}
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .animate-slideIn {
          animation: slideIn 0.3s ease-out forwards;
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
      `}</style>
    </>
  );
};

export default NavMobile;